const sl = {
  brand: {
    name: 'Črna Kuhna',
    tagline: 'Iz ognja. Iz Prlekije. Za skupno mizo.',
    region: 'Vinski Vrh · Miklavž pri Ormožu',
  },
  photo: {
    badge: 'Pristna fotografija',
  },
  nav: {
    home: 'Domov',
    story: 'Zgodba',
    menu: 'Jedilnik',
    wines: 'Vina',
    gallery: 'Galerija',
    visit: 'Obisk',
    events: 'Dogodki',
    gift: 'Darilni boni',
  },
  cta: {
    reserve: 'Rezerviraj mizo',
    menu: 'Poglej jedilnik',
    call: 'Pokliči',
    email: 'Piši nam',
    directions: 'Odpri navigacijo',
    inquire: 'Pošlji povpraševanje',
    back: 'Nazaj domov',
  },
  contact: {
    phone: '+386 71 825 143',
    phoneHref: '+38671825143',
    email: 'crnakuhna.mb@gmail.com',
    addressLine1: 'Vinski Vrh 6',
    addressLine2: '2275 Miklavž pri Ormožu, Slovenija',
    mapsQuery: 'Vinski Vrh 6, 2275 Miklavž pri Ormožu, Slovenija',
  },
  lang: {
    label: 'Jezik',
    sl: 'Slovenščina',
    en: 'English',
  },
  footer: {
    tagline: 'Iz ognja. Iz Prlekije. Za skupno mizo.',
    linksTitle: 'Povezave',
    contactTitle: 'Kontakt',
    visitTitle: 'Obisk',
    hoursNote: 'Odprto od četrtka do nedelje; ponedeljek–sreda zaprto.',
    rights: 'Vse pravice pridržane.',
    notFoundTitle: 'Stran ni najdena',
    notFoundText: 'Te strani ni mogoče najti. Vrnite se domov in poskusite znova.',
  },
};

export default sl;